import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function CtaStrip() {
  return (
    <section className="relative py-20 lg:py-28 bg-white overflow-hidden">
      <div className="max-w-[1360px] mx-auto px-5 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9 }}
          className="relative rounded-[32px] overflow-hidden bg-slate-900 text-white px-8 lg:px-16 py-16 lg:py-24"
        >
          <div
            className="absolute inset-0 opacity-70 pointer-events-none"
            style={{
              background:
                "radial-gradient(circle at 15% 15%, rgba(213,32,39,0.35), transparent 45%), radial-gradient(circle at 85% 85%, rgba(31,60,136,0.5), transparent 45%)",
            }}
          />
          <div className="grain" />

          <div className="relative grid lg:grid-cols-12 gap-10 items-end">
            <div className="lg:col-span-8">
              <span className="ticker text-slate-400">
                Nästa steg
              </span>
              <h2 className="hero-text mt-5 text-[10vw] sm:text-[7vw] lg:text-[5vw] xl:text-[90px] text-white">
                Dags att ge bilen<br />
                <span className="italic text-[#D52027]">rätt hjälp</span>
                <span className="italic text-white">.</span>
              </h2>
            </div>
            <div className="lg:col-span-4 flex lg:justify-end">
              <a
                href="#boka"
                data-testid="cta-strip-book"
                className="btn-primary"
              >
                Skicka bokningsförfrågan
                <ArrowUpRight className="h-[18px] w-[18px]" />
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
